import { useState, type FC } from 'react';
import { Button, Space } from '@g2u/ui-kit';
import { Form, Tooltip } from 'antd';

import { NoteType, type WithOptionalDataTest } from 'types';
import { AddNotePopconfirm } from '.';
import { validateFormSilently } from 'helpers';

import styles from '../tickets.module.scss';

type Props = {
  isLoading?: boolean;
  lockedBy?: string;
  onClose: (args: { taskId: number; noteTypeId: number; note: string }) => void;
  taskId: number;
  noteTypes?: NoteType[];
  onSms: () => void;
  onEmail: () => void;
  onCall: () => void;
} & WithOptionalDataTest;

export const TicketActions: FC<Props> = (props) => {
  const { onClose, onSms, onEmail, onCall, isLoading, lockedBy, noteTypes, taskId } = props;

  const [form] = Form.useForm();
  const [isCloseFormValid, setIsCloseFormValid] = useState<boolean>(false);

  const handleTicketClose = () => {
    onClose({ taskId, note: form.getFieldValue('newNote'), noteTypeId: form.getFieldValue('noteType') });
  };

  return (
    <>
      <Tooltip title={lockedBy ? `Locked by ${lockedBy}` : undefined} placement="topLeft">
        <div>
          <Space.$>
            <Form
              form={form}
              layout="vertical"
              colon={false}
              onValuesChange={() => validateFormSilently(form, setIsCloseFormValid)}
              className={styles.tickets__detailsColumn}
            >
              <AddNotePopconfirm
                title="Closing Summary"
                form={form}
                noteTypes={noteTypes}
                isFormValid={isCloseFormValid}
                onConfirm={handleTicketClose}
              >
                <Button.$
                  type={Button.Type.Primary}
                  dataTestId="close-ticket-btn"
                  onClick={() => null}
                  loading={isLoading}
                  disabled={!!lockedBy || isLoading}
                >
                  Close Ticket
                </Button.$>
              </AddNotePopconfirm>
            </Form>
            <Button.$
              type={Button.Type.Default}
              dataTestId="send-sms-button"
              onClick={onSms}
              loading={isLoading}
              disabled={!!lockedBy || isLoading}
            >
              Send Sms
            </Button.$>
            <Button.$
              type={Button.Type.Default}
              dataTestId="send-email-button"
              onClick={onEmail}
              loading={isLoading}
              disabled={!!lockedBy || isLoading}
            >
              Send Email
            </Button.$>
            <Button.$
              type={Button.Type.Default}
              dataTestId="call-button"
              onClick={onCall}
              loading={isLoading}
              disabled={!!lockedBy || isLoading}
            >
              Call
            </Button.$>
          </Space.$>
        </div>
      </Tooltip>
    </>
  );
};
